import { render, staticRenderFns } from "./UpLoadTable.vue?vue&type=template&id=360ed15c&"
import script from "./UpLoadTable.vue?vue&type=script&lang=js&"
export * from "./UpLoadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports